import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_REPORT] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.report = payload
  },
  [types.SET_REPORTS] (state, payload) {
    state.reports = payload.data
    state.pagination = payload.meta.pagination
  }
}
